import { FormControl, FormGroup } from '@angular/forms';
import { Guid, Nillable } from '@web/utils';
import { InPostPointSelect } from '@web/shared/ui';
import { PhoneNumberWithPrefix } from '@web/shared/module/dictionary';

export type PublicOrderShippingAddressFormControls = {
  city: FormControl<Nillable<string>>;
  companyName: FormControl<Nillable<string>>;
  countryId: FormControl<Nillable<Guid>>;
  email: FormControl<Nillable<string>>;
  firstName: FormControl<Nillable<string>>;
  lastName: FormControl<Nillable<string>>;
  phone: FormControl<Nillable<PhoneNumberWithPrefix>>;
  postCode: FormControl<Nillable<string>>;
  shippingMethodId: FormControl<Nillable<Guid>>;
  shippingPoint: FormControl<Nillable<InPostPointSelect>>;
  state: FormControl<Nillable<string>>;
  streetLine1: FormControl<Nillable<string>>;
  streetLine2: FormControl<Nillable<string>>;
};

export class PublicOrderShippingAddressForm {
  public static FirstNameMaxLength = 100;
  public static LastNameMaxLength = 100;
  public static StreetMaxLength = 255;
  public static PostCodeMaxLength = 30;
  public static CityMaxLength = 100;
  public static StateMaxLength = 100;
  public static CompanyNameMaxLength = 255;

  public constructor(
    private readonly data: {
      city?: Nillable<string>;
      companyName?: Nillable<string>;
      countryId?: Nillable<Guid>;
      email?: Nillable<string>;
      firstName?: Nillable<string>;
      lastName?: Nillable<string>;
      phone?: Nillable<PhoneNumberWithPrefix>;
      postCode?: Nillable<string>;
      state?: Nillable<string>;
      streetLine1?: Nillable<string>;
      streetLine2?: Nillable<string>;
      shippingMethodId?: Nillable<Guid>;
      shippingPoint?: Nillable<InPostPointSelect>;
    },
  ) {}

  public get city(): Nillable<string> {
    return this.data.city;
  }

  public get companyName(): Nillable<string> {
    return this.data.companyName;
  }

  public get countryId(): Nillable<Guid> {
    return this.data.countryId;
  }

  public get email(): Nillable<string> {
    return this.data.email;
  }

  public get firstName(): Nillable<string> {
    return this.data.firstName;
  }

  public get lastName(): Nillable<string> {
    return this.data.lastName;
  }

  public get phone(): Nillable<PhoneNumberWithPrefix> {
    return this.data.phone;
  }

  public get postCode(): Nillable<string> {
    return this.data.postCode;
  }

  public get state(): Nillable<string> {
    return this.data.state;
  }

  public get streetLine1(): Nillable<string> {
    return this.data.streetLine1;
  }

  public get streetLine2(): Nillable<string> {
    return this.data.streetLine2;
  }

  public get shippingMethodId(): Nillable<Guid> {
    return this.data.shippingMethodId;
  }

  public get shippingPoint(): Nillable<InPostPointSelect> {
    return this.data.shippingPoint;
  }
}

/* prettier-ignore */
export type PublicOrderShippingAddressFormGroup = FormGroup<PublicOrderShippingAddressFormControls>;
